import { Workbox } from 'workbox-window';

export default async () => {
  if ('serviceWorker' in navigator) {
    const wb = new Workbox('/sw-menu.js');

    // todo: double check with Google docs if it's a good approach
    wb.addEventListener('installed', (event) => {
      // reload page when sw is first installed to make sure
      // that all runtime caching works even during the first visit
      if (!event.isUpdate) {
        window.location.reload();
      }
    });

    await wb.register();
  }
};
